import React from 'react';
import classes from './Tag.module.scss';
import tagConfigs from './tagConfigs';
import Txt from 'components/atoms/Txt/Txt';
import clsx from 'clsx';
import Heading from 'components/atoms/Heading/Heading';
import type { OfferType } from 'utils/offers';

export interface TagProps {
  tag: string;
  type: OfferType | 'survey';
  className?: string;
  detailed?: boolean;
}

const TagDescription: React.FC<TagProps> = function Tag({ detailed, tag, type, className }) {
  const config = tagConfigs[type][tag];
  return config ? (
    <div className={clsx(classes.tagDescription, className)}>
      <config.Icon className={classes.icon} />
      <div className={classes.tagContent}>
        <Heading level={4}>{config.title}</Heading>
        <Txt component="p">{(detailed && config.detailedDescription) || config.description}</Txt>
      </div>
    </div>
  ) : null;
};
export default TagDescription;
